//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Mixins
import Heading from '@/mixins/heading';

export default {
  name: 'BaseInfoCard',

  mixins: [Heading],

  props: {
    dark: Boolean,
    callout: { type: String, default: null },
    color: {
      type: String,
      default: 'grey',
    },
    icon: { type: [String, Object], default: null },
    subtitle: { type: String, default: null },
    text: { type: String, default: null },
    title: { type: String, default: null },
    level: { type: Number, default: 3 },
  },
};
